export default "__VITE_ASSET__BD7aCg3d__";